/**
 * @fileoverview Componente principal de la aplicación que maneja la configuración inicial
 * y la estructura base de la interfaz.
 */
import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

import { ThemeService } from '../protected-area/services/theme.service';
import { setupPrimeNGConfig } from './primeng-config';
import { MockDataService } from './services/mock-data.service';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast, ConfirmDialog],
  template: `<p-toast [position]="'top-right'" [preventOpenDuplicates]="true"></p-toast>
    <p-confirmdialog />
    <router-outlet />`,
  providers: [MessageService, ConfirmationService],
})
export class AppComponent implements OnInit {
  private primengConfig = inject(PrimeNG);
  private themeService = inject(ThemeService);
  private authService = inject(AuthService);
  private mockDataService = inject(MockDataService);

  constructor() {}

  ngOnInit() {
    setupPrimeNGConfig(this.primengConfig);
    this.themeService.initializeTheme();

    this.mockDataService.setAuthContext(
      () => this.authService.hasRole('Usuarios.Administrador'),
      () => {
        const userInfo = localStorage.getItem('userInfo');
        return userInfo ? JSON.parse(userInfo).organoId : undefined;
      },
    );
  }
}
